import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export default {
  namespaced: true,
  state: () => ({
    list: [],
  }),
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/companyFiles/index.js